import { t } from 'i18next';
import { formatFormName, formatRequestFormDate } from './utils';

export const rowsHead = [
  { name: 'Attendee Name' },
  { name: 'Contact No.' },
  { name: 'Payment Method' },
  { name: 'Transaction ID' },
  { name: 'Registration ID' },
  { name: 'Total Amount' },
  { name: 'Paid Amount' },
  { name: 'Discount Amount' },
  { name: 'Event Country' },
  { name: 'Payment Status' }
];

export const myVouchersColumnName = [
  { name: t('myVouchers.voucherCode') },
  { name: t('myVouchers.courseName') },
  { name: t('myVouchers.startDate') },
  { name: t('myVouchers.endDate') },
  { name: t('myVouchers.amount') },
  { name: t('myVouchers.action') }
];

export const rowsHeadRegistrationReport = [
  { id: 'fullName', label: t('accessPortal.tableHead.fullName'), sortable: true },
  { id: 'email', label: t('accessPortal.tableHead.emailAddress'), sortable: true },
  { id: 'company', label: t('accessPortal.tableHead.company'), sortable: true },
  { id: 'address', label: t('accessPortal.tableHead.address'), sortable: true },
  { id: 'city', label: t('accessPortal.tableHead.cityStateZip'), sortable: true },
  { id: 'phone', label: t('accessPortal.tableHead.phone'), sortable: true },
  { id: 'npi', label: t('accessPortal.tableHead.npi'), sortable: true },
  { id: 'lincense', label: t('accessPortal.tableHead.lincense'), sortable: true },
  { id: 'lincenseState', label: t('accessPortal.tableHead.lincenseState'), sortable: true },
  { id: 'speciality', label: t('accessPortal.tableHead.speciality'), sortable: true },
  { id: 'contactType', label: t('accessPortal.tableHead.contactType'), sortable: true },
  { id: 'admissionItem', label: t('accessPortal.tableHead.admissionItem'), sortable: true }
];

export const rowsHeadAttendee = [
  { id: 'name', label: t('attendee.attendeeName'), sortable: true },
  { id: 'email', label: t('attendee.emailAddress'), sortable: true },
  { id: 'contactType', label: t('attendee.contactType'), sortable: true },
  { id: 'phoneNumber', label: t('attendee.phoneNumber'), sortable: true },
  { id: 'country', label: t('attendee.country'), sortable: true }
];

export const rowsHeadManageRepresentatives = [
  {
    id: 'representativeName',
    label: t('manageRepresentatives.representativeName'),
    sortable: true
  },
  { id: 'group', label: t('manageRepresentatives.group'), sortable: true },
  { id: 'email', label: t('manageRepresentatives.email'), sortable: true },
  { id: 'status', label: t('manageRepresentatives.status'), sortable: true },
  { id: 'action', label: t('manageRepresentatives.action') }
];

export const rowsHeadSpeakerManagement = [
  { id: 'speakerName', label: t('speakerManagement.speakerName'), sortable: true },
  { id: 'speakerDesignation', label: t('speakerManagement.designation'), sortable: true },
  { id: 'speakerBioDetails', label: t('speakerManagement.bio'), sortable: true },
  { id: 'speakerCategory', label: t('speakerManagement.category'), sortable: true },
  { id: 'speakerAction', label: t('speakerManagement.action'), sortable: true }
];

export const rowsDiscountHead = [
  { name: t('discount.code'), id: 'discountCode', sortable: true },
  { name: t('discount.discountOrVoucher'), id: 'numberOfDiscounts', sortable: true },
  { name: t('discount.courseName'), id: 'eventName', sortable: true },
  { name: t('discount.amountValue'), id: 'discountAmount', sortable: true },
  { name: t('discount.contactType'), id: 'registrationType', sortable: true },
  { name: t('discount.startDate'), id: 'startDate', sortable: true },
  { name: t('discount.endDate'), id: 'endDate', sortable: true },
  { name: t('discount.stackableOrNonStackable'), id: 'isStackable', sortable: true },
  { name: t('discount.status'), id: 'status', sortable: true },
  { name: t('discount.action'), sortable: false }
];

export const formLinks = [
  { label: 'TEST - US Education Material Hands-on Request Form', url: '#' },
  { label: 'TEST Canada Education Materials Hands-on Request Form', url: '#' },
  { label: 'Dental – Regional Education Meeting Request (US)', url: '#' },
  { label: 'TEST - US Education Material Hands-on Request Form', url: '#' }
];

export const requestFormApproverColumnName = [
  { id: 'formType', label: t('admin.requestFormApprover.formType'), sortable: true },
  { id: 'field', label: t('admin.requestFormApprover.field'), sortable: true },
  {
    id: 'field_university_request',
    label: t('admin.requestFormApprover.educationType'),
    sortable: true
  },
  { id: 'region', label: t('admin.requestFormApprover.region'), sortable: true },
  { id: 'approverEmail', label: t('admin.requestFormApprover.primaryApprover'), sortable: true },
  {
    id: 'secondApproverEmailAddress',
    label: t('admin.requestFormApprover.secondaryApprover'),
    sortable: true
  },
  {
    id: 'thirdApproverEmailAddress',
    label: t('admin.requestFormApprover.tertiaryApprover'),
    sortable: true
  },
  { id: 'approverAction', label: t('admin.requestFormApprover.action'), sortable: false }
];

export const dashboardRequestFormData = [
  {
    id: 'requestFormType',
    label: 'accessPortal.requestFormType',
    sortable: true,
    render: (data, isLatest) => (
      <>
        {formatFormName(data?.requestFormType)}
        {isLatest && <span className="new-btn">{t('requestFormTable.new')}</span>}
      </>
    )
  },
  {
    id: 'createdOn',
    label: 'requestFormTable.createdOn',
    sortable: true,
    render: (data) => formatRequestFormDate(data?.createdOn)
  },
  {
    id: 'createdBy',
    label: 'requestFormTable.createdBy',
    adminOnly: true,
    sortable: true,
    render: (data) => data?.name
  },
  {
    id: 'status',
    label: 'requestFormTable.status',
    sortable: true,
    render: (data) => <span className="pending-btn">{data?.status}</span>
  }
];

export const voucherPaymentColumns = [
  { name: '' },
  { name: t('myVouchers.voucherCode') },
  { name: t('myVouchers.courseName') },
  { name: t('myVouchers.amount') }
];
